module.exports = __webpack_public_path__ + "static/media/S2.efeb6a66.png";